import Store from '@/globals/store.js'
import SecretaryIndex from '@/views/doctor/index'
import SecretaryLogin from '@/views/doctor/Login'
// import SecretaryDashboard from '@/views/doctor/Dashboard'
import SecretaryAgenda from '@/views/doctor/Agenda'
import SecretaryUser from '@/views/secretary/User'
import SecretaryPrices from '@/views/doctor/Prices'
import SecretaryPatients from '@/views/doctor/Patients'
import SecretaryPatientsList from '@/components/layout/patient/list'
import SecretaryPatientsDetails from '@/components/layout/appointments/patientDetails.vue'
import SecretaryAppointments from '@/views/doctor/Appointments'
import SecretaryAppointmentsList from '@/components/layout/appointments/list'
import SecretaryPatientsImport from '@/components/layout/patient/import/'
import SecretaryAppointmentsGuide from '@/components/layout/appointments/guide'
import SecretaryPatientsImportPreview from '@/components/layout/patient/import/preview'
import SecretaryPatientsImportIdentify from '@/components/layout/patient/import/identifyColumns'
import SecretaryPatientsImportExecute from '@/components/layout/patient/import/actionPreview'
import SecretaryPatientsImportFinished from '@/components/layout/patient/import/finished'
// import SecretaryProcedures from '@/views/doctor/Procedures'
import SecretaryFinances from '@/views/doctor/Finances'
import SecretaryFinancesOverview from '@/components/layout/finances/overview'
import SecretaryFinancesDetailed from '@/components/layout/finances/detailed'
import SecretaryUsersOffice from '@/views/doctor/UsersOffice'
import SecretaryUsersOfficeList from '@/components/layout/users-office/list'
import SecretaryUsersOfficeForm from '@/components/layout/users-office/form'
import SecretaryHistory from '@/views/doctor/History'
import SecretaryHistoryList from '@/components/layout/history/list'
import tableContainer from '@/components/tables/tableContainer.vue'

let children = [
  {
    path: 'doctor/:doctorId',
    meta: {
      accessRoles: []
    }
  },
  // {
  //   path: 'doctor/:doctorId/dashboard',
  //   name: 'SecretaryDashboard',
  //   component: SecretaryDashboard,
  //   meta: {
  //     sidebar: true,
  //     accessRoles: ['ACCESS_PANEL'],
  //     title: 'Meu painel',
  //     icon: 'painel'
  //   }
  // },
  {
    path: 'doctor/:doctorId/agenda',
    name: 'SecretaryAgenda',
    component: SecretaryAgenda,
    meta: {
      sidebar: true,
      accessRoles: ['ACCESS_AGENDA'],
      title: 'Agenda',
      icon: 'agenda'
    },
    children: [
      {
        path: ':doctorOffice/new',
        name: 'SecretaryAgendaNew',
        component: SecretaryAgenda,
        meta: {
          new: true
        }
      }
    ]
  },
  {
    path: 'doctor/:doctorId/appointments',
    component: SecretaryAppointments,
    name: 'SecretaryAppointments',
    meta: {
      sidebar: true,
      accessRoles: ['ACCESS_MEDICAL_CONSULTATION'],
      title: 'Agendamentos',
      icon: 'consultas'
    },
    redirect: { name: 'SecretaryAppointmentsList' },
    children: [
      {
        path: 'list',
        name: 'SecretaryAppointmentsList',
        component: SecretaryAppointmentsList
      },
      {
        path: 'guide/:agendaId',
        name: 'SecretaryAppointmentsGuide',
        component: SecretaryAppointmentsGuide
      },
      {
        path: ':patientType/:id/:agendaId',
        name: 'SecretaryAppointmentsDetails',
        component: SecretaryPatientsDetails
      }
    ]
  },
  {
    path: 'doctor/:doctorId/patients',
    component: SecretaryPatients,
    name: 'SecretaryPatients',
    meta: {
      sidebar: true,
      accessRoles: ['ACCESS_PATIENT'],
      title: 'Pacientes',
      icon: 'pacientes'
    },
    redirect: '/secretary/doctor/:doctorId/patients/list/specialPatient',
    children: [
      {
        path: 'list/:type?',
        component: SecretaryPatientsList,
        name: 'SecretaryPatientsList',
        redirect: { name: 'SecretaryPatientsListDetails' },
        children: [
          {
            path: '',
            name: 'SecretaryPatientsListDetails',
            component: tableContainer
          }
        ]
      },
      {
        path: 'import',
        name: 'SecretaryPatientsImport',
        redirect: { name: 'SecretaryPatientsImportPreview' },
        component: SecretaryPatientsImport,
        children: [
          {
            path: '',
            name: 'SecretaryPatientsImportPreview',
            component: SecretaryPatientsImportPreview
          },
          {
            path: ':type/identify',
            name: 'SecretaryPatientsImportIdentify',
            component: SecretaryPatientsImportIdentify
          },
          {
            path: ':type/execute',
            name: 'SecretaryPatientsImportExecute',
            component: SecretaryPatientsImportExecute
          },
          {
            path: ':type/finished',
            name: 'SecretaryPatientsImportFinished',
            component: SecretaryPatientsImportFinished
          }
        ]
      },
      {
        path: 'details/:patientType/:id',
        name: 'SecretaryPatientsDetails',
        component: SecretaryPatientsDetails
      }
    ]
  },
  {
    path: 'doctor/:doctorId/finances',
    name: 'SecretaryFinances',
    component: SecretaryFinances,
    redirect: { name: 'SecretaryFinancesOverview' },
    meta: {
      sidebar: true,
      accessRoles: ['ACCESS_FINANCIAL_STATEMENT'],
      title: 'Extrato',
      icon: 'extrato'
    },
    children: [
      {
        path: 'overview',
        name: 'SecretaryFinancesOverview',
        component: SecretaryFinancesOverview
      },
      {
        path: 'list',
        name: 'SecretaryFinancesDetailed',
        component: SecretaryFinancesDetailed
      }
    ]
  },
  {
    path: 'doctor/:doctorId/prices',
    name: 'SecretaryPrices',
    component: SecretaryPrices,
    meta: {
      sidebar: true,
      accessRoles: [],
      title: 'Preços',
      icon: 'precos'
    }
  },
  {
    path: 'doctor/:doctorId/users',
    component: SecretaryUsersOffice,
    name: 'SecretaryUsersOffice',
    meta: {
      sidebar: true,
      accessRoles: [],
      title: 'Usuários',
      icon: 'usuarios'
    },
    redirect: { name: 'SecretaryUsersOfficeList' },
    children: [
      {
        path: 'list',
        name: 'SecretaryUsersOfficeList',
        component: SecretaryUsersOfficeList
      },
      {
        path: 'new',
        name: 'SecretaryUsersOfficeNew',
        component: SecretaryUsersOfficeForm
      },
      {
        path: 'edit/:id',
        name: 'SecretaryUsersOfficeEdit',
        component: SecretaryUsersOfficeForm
      }
    ]
  },
  {
    path: 'doctor/:doctorId/history',
    name: 'SecretaryHistory',
    component: SecretaryHistory,
    meta: {
      sidebar: true,
      accessRoles: ['ACCESS_HISTORY'],
      title: 'Histórico',
      icon: 'historico'
    },
    redirect: { name: 'SecretaryHistoryList' },
    children: [
      {
        path: '',
        name: 'SecretaryHistoryList',
        component: SecretaryHistoryList
      }
    ]
  },
  {
    path: 'user',
    name: 'SecretaryUser',
    component: SecretaryUser,
    meta: {
      title: 'Minha conta',
      accessRoles: []
    }
  },
  {
    path: 'doctor/:doctorId/login',
    name: 'SecretaryLogin',
    component: SecretaryLogin,
    meta: {
      sidebar: false,
      accessRoles: []
    }
  }
]

for (let child of children) {
  child.beforeEnter = (to, from, next) => {
    if (Store.getters.getRoles.indexOf('ROLE_SECRETARY') === -1 && !Store.getters.$_checkAuth) {
      Store.dispatch('setModalAlert', {
        title: 'Erro de autenticação',
        body: 'Acesso não permitido',
        size: 'md',
        active: true
      })
      next('/')
      return
    }
    if (!Store.getters.$_checkAuth) {
      next('/')
      return
    }
    for (let route of children) {
      for (let role of route.meta.accessRoles) {
        if (Store.getters.getAccessRoles.join(' ').search(role) > -1) {
          next(route.fullPath)
          return
        }
      }
      if (route.meta.accessRoles.length === 0) {
        if (route.name !== to.name) {
          next(route.fullPath)
          return
        }
      }
    }
  }
}
export default {
  path: '/secretary',
  name: 'Secretary',
  component: SecretaryIndex,
  children
}
